import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";

import {
  ModalAssets,
  DEFAULT_ASSETS_BASE,
  STORE_LINKS
} from "./download-modal.constants";
import { SiilaTranslationService } from "../../core/services/siila-translation.service";

const SESSION_KEY = "spot_download_modal_shown";

@Injectable({ providedIn: "root" })
export class DownloadModalService {
  constructor(
    private router: Router,
    private deviceDetector: DeviceDetectorService,
    private translationService: SiilaTranslationService
  ) {}

  shouldShowModal(): boolean {
    try {
      if (this.deviceDetector.isDesktop()) {
        return false;
      }
      const path = window.location.pathname || "";
      const lower = path.toLowerCase();
      if (lower.includes("/products") || lower.includes("/solutions")) {
        return false;
      }

      if (sessionStorage.getItem(SESSION_KEY) === "true") {
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  getPlatform(): "ios" | "android" {
    const os = (this.deviceDetector.os || "").toLowerCase();
    if (os.indexOf("ios") !== -1) {
      return "ios";
    }
    if (os.indexOf("android") !== -1) {
      return "android";
    }
    return "android";
  }

  getLanguage(): string {
    try {
      const lang = this.translationService.getCurrentLanguage();
      if (!lang) return "en";
      if (lang.startsWith("pt")) return "pt";
      if (lang.startsWith("en")) return "en";
      if (lang.startsWith("es")) return "es";
      return "en";
    } catch (e) {
      return "en";
    }
  }

  getAssetsForModal(language?: string, platform?: string): ModalAssets {
    const lang = language || this.getLanguage();
    const plat = platform || this.getPlatform();

    const bannerPath = `${DEFAULT_ASSETS_BASE}/${lang}-DOWNLOAD APP 1.png`;
    const btnFile =
      plat === "ios"
        ? "App iOS button.png"
        : plat === "android"
        ? "App Android button.png"
        : "App Android button.png";
    const buttonPath = `${DEFAULT_ASSETS_BASE}/${btnFile}`;

    const linksForLang = (STORE_LINKS as any)[lang] || STORE_LINKS["en"];
    const storeLink =
      plat === "ios"
        ? linksForLang.ios
        : plat === "android"
        ? linksForLang.android
        : linksForLang.android;

    return {
      bannerPath,
      buttonPath,
      storeLink
    };
  }

  markShown(): void {
    try {
      sessionStorage.setItem(SESSION_KEY, "true");
    } catch (e) {}
  }
}
